import React, { FunctionComponent } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../helpers";

interface FootnoteProps {
  id: string;
  className?: string;
  text: string | JSX.Element;
  marker?: string;
  linkMarker?: boolean;
}

const Footnote: FunctionComponent<FootnoteProps> = ({
  className = "",
  id,
  text,
  marker,
  linkMarker = false,
}) => {
  const t = useTranslate();
  const footnoteId = `${id}-footnote`;
  const markerId = `${id}-marker`;
  const FootnoteMarker: React.FC<{ link?: boolean }> = ({ link = false }) => {
    const markerLabel = <sup>{marker}</sup>;
    return marker ? (
      link ? (
        markerLabel
      ) : (
        <div className="Footnote__marker ds-c-button--small">{markerLabel}</div>
      )
    ) : null;
  };

  return (
    <>
      <dt className="Footnote__dt">Footnote {marker}</dt>
      <dd
        id={footnoteId}
        className="Footnote__dd"
        tabIndex={marker ? -1 : undefined}
      >
        <p className={marker ? `ds-u-margin-left--1 ${className}` : ""}>
          {text}
        </p>
        {marker && linkMarker ? (
          <Button
            size="small"
            className="Footnote__marker Footnote__marker--linked"
            aria-label={t("footnote.return_to_content")}
            onClick={(): void => {
              const marker: HTMLButtonElement | null = document.querySelector(
                `#${markerId}`
              );
              marker?.scrollIntoView();
              marker?.focus();
            }}
          >
            <FootnoteMarker link={true} />
          </Button>
        ) : (
          <FootnoteMarker />
        )}
      </dd>
    </>
  );
};

export default Footnote;
